import { useCallback, useState } from 'react';

import { IUnitedSections } from 'constants/businessToolSections';

export interface IControllers extends Record<IUnitedSections, AbortController> {}

export const useControllerManagement = () => {
  const [controllers, setControllers] = useState<IControllers>({} as IControllers);

  const addController = useCallback((sectionKey: IUnitedSections) => {
    const controller = new AbortController();
    setControllers((prev) => ({ ...prev, [sectionKey]: controller }));
    return controller;
  }, []);

  const removeController = useCallback((sectionKey: IUnitedSections) => {
    setControllers((prev) => {
      const newControllers = { ...prev };
      delete newControllers[sectionKey];
      return newControllers;
    });
  }, []);

  const abortController = useCallback(
    (sectionKey: IUnitedSections) => {
      controllers[sectionKey]?.abort();
      removeController(sectionKey);
    },
    [controllers, removeController],
  );

  const abortAllControllers = useCallback(() => {
    Object.keys(controllers).forEach((key) => {
      controllers[key as keyof IControllers]?.abort();
    });
    setControllers({} as IControllers); // Clear all controllers after aborting them
  }, [controllers]);

  return { controllers, addController, removeController, abortController, abortAllControllers };
};
